import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTradingNumericBase } from './useTradingNumericBase';
import { useNumericArrows } from '../../NumericComponents/NumericArrows/useNumericArrows';
import { useNumericValidation } from '../../NumericComponents/NumericValidation/useNumericValidation';
import { validateStep } from '../../NumericComponents/NumericValidation/numericValidation';
import { NumericContainer } from '../../NumericComponents/NumericContainer/NumericContainer';
import { NumericInput } from '../../NumericComponents/NumericInput/NumericInput';
import { NumericArrows } from '../../NumericComponents/NumericArrows/NumericArrows';
export const TradingNumeric = ({ value, variableTickList, incrementInTicks, offsetType, onValueChange }) => {
    const { min, max, precision, onIncrement, onDecrement } = useTradingNumericBase({
        value,
        variableTickList,
        incrementInTicks,
        offsetType
    });
    const { validationError } = useNumericValidation({
        value,
        min,
        max,
        step: incrementInTicks,
        precision,
        validationCallback: (params) => validateStep(params, incrementInTicks)
    });
    const { handleIncrement, handleDecrement } = useNumericArrows({
        value,
        onIncrement,
        onDecrement,
        onValueChange
    });
    return (_jsxs(NumericContainer, { disabled: false, validationError: validationError, children: [_jsx(NumericInput, { value: value, step: incrementInTicks, onValueChange: onValueChange, min: min, max: max, precision: precision, onIncrement: onIncrement, onDecrement: onDecrement }), _jsx(NumericArrows, { onIncrement: handleIncrement, onDecrement: handleDecrement })] }));
};
